<template>
<div class="entry-wrapper">
  <div class="entry-row">
    <el-button class="entry-button" @click="onSelectCollege">智能填报</el-button>
    <el-button class="entry-button" @click="onQueryCollege">高校信息</el-button>
    <el-button class="entry-button" @click="onJobTest">职业倾向测试</el-button>
    <el-button class="entry-button" @click="onSelectSubject">新高考选科</el-button>
  </div>
  <div class="entry-row">
    <el-button class="entry-button" @click="onScoreSegment">一分一段表</el-button>
    <el-button class="entry-button">
      <a :href="planUrl" target="_blank">三位一体强基计划</a>
    </el-button>
    <el-button class="entry-button" @click="onPreEnroll">提前批考栏</el-button>
    <el-button class="entry-button" @click="onQuestionAnswer">专家问答</el-button>
  </div> 
</div> 
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      jobtestUrl: '',
      planUrl: '',
    };
  },
  computed:{
    ...mapState({
      userinfo: 'userinfo'
    })
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      const that = this
      that.axios.get('/homepage/entry/list')
      .then(res =>{
        let {code, data, message}=res;
        if(code==0){
          data.forEach(element => {
            if(element.entry_name==='职业倾向测试')
              that.jobtestUrl = element.link_url
            else if(element.entry_name==='三位一体强基计划')
              that.planUrl = element.link_url
          });
        }else{
          that.$message(message)
        }
      })
    },
    onJobTest(){
      if(!this.userinfo.isVip){
        this.$message('需要VIP权限，请联系管理员')
        return
      }
      window.location.href = this.planUrl
    },
    onScoreSegment(){
      this.$router.push({ path: '/scoresegment' })
    },
    onQuestionAnswer(){
      this.$router.push({ path: '/questionanswer' })
    },
    onSelectSubject(){
      this.$router.push({ path: '/selectsubject' })
    },
    onSelectCollege(){
      this.$router.push({ path: '/selectcollege' })
    },
    onQueryCollege(){
      this.$router.push({ path: '/queryCollege' })
    },
    onPreEnroll(){
      this.$router.push({ path: '/preEnroll' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.entry-wrapper
  margin: 10px 60px 10px 60px
  .entry-row
    display: flex
    justify-content : space-between
    margin: 10px 0px 10px 0px
    .entry-button
      font-size: 20px
      width: 300px

</style>